<template>
  <li v-if="!item.excludeNavigation" :key="item.name">
    <a :href="`#${item.name}`"
      @click.prevent="navigateTo(item.name)"
      :class="{active: isActive}"
    >{{item.headline}}</a>
  </li>
</template>

<script>
export default {
  name: 'MainNavigationItem',
  props: ['item'],
  data() {
    return {
      isActive: false
    }
  },
  mounted() {
    const self = this;
    this.$bus.$on('activeSection', (data) => {
      self.isActive = data.name === self.item.name;
    });
  },
  methods: {
    navigateTo(name) {
      this.$bus.$emit('navigateTo', { name });
      this.$bus.$emit('toggleNav', { isOpen: false });
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '../../assets/sass/_vars.sass'

  a
    text-decoration: none
    text-transform: uppercase
    display: block
    text-align: right
    padding: .25em 0
    color: $colorPrimary
    font-weight: 200
    letter-spacing: .2em
    transition: color 180ms ease-out

    &:hover, &.active
      color: #000

</style>
